import React from 'react';

import PropTypes from 'prop-types';

import { AddressInput } from './address-input';
import { AutoCompleteField } from '../../../constants/autocomplete-field';
import { FIELD_NAMES } from '../constants';

export const Line3Field = ({ optional = false }) => {
  return <AddressInput autoComplete={AutoCompleteField.AddressLine3} field={FIELD_NAMES.LINE3} optional={optional} />;
};

Line3Field.propTypes = {
  optional: PropTypes.bool,
};
